export default "__VITE_ASSET__WwLTIlue__"